/** Formatea un monto en quetzales guatemaltecos: 35000 -> "Q35,000" */
export function formatQ(amount: number): string {
  return `Q${Math.round(amount).toLocaleString('en-US')}`
}

/**
 * Cuota mensual de un crédito con amortización francesa.
 * @param principal monto a financiar
 * @param annualRate tasa nominal anual (0.18 = 18%)
 * @param months plazo en meses
 */
export function monthlyPayment(principal: number, annualRate: number, months: number): number {
  const r = annualRate / 12
  if (r === 0) return principal / months
  return (principal * r) / (1 - Math.pow(1 + r, -months))
}
